export const flashDealsPage = {
  seo: {
    title: "Flash Deals - Captex",
    description: "Limited-time Captex flash deals.",
  },
  hero: {
    eyebrow: "Flash Deals",
    title: "Limited time offers",
    description: "Grab selected styles at a reduced price while stock lasts.",
    endsAt: "2026-07-31T23:59:59+06:00",
  },
  tabs: [
    { value: "all", label: "All Deals" },
    { value: "limited", label: "Limited" },
    { value: "best-seller", label: "Best Seller" },
  ],
  callToAction: {
    title: "Don't miss the drop.",
    description: "Explore all flash deals before they expire.",
    buttonText: "Shop Now",
    href: "/shop",
  },
};
